import $ from 'jquery';
import * as CONST from '../../common/utils/constants';
import Util from '../../common/utils/ui';

class MeetTeam {
    constructor() {
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        $('.listing-image img').on('error', (event) => {
			// on img error: replace src to placeholder
            $(event.target).attr('src', '/Content/images/custom/agent-placeholder-avatar.png').addClass('no-image');
		});
    }
}

export default MeetTeam;

$(() => {
	const meetTeam = new MeetTeam();
	meetTeam.init();
});